// ⚠⚠ THE COLUMNS OF `node_metadata` THAT THE APP SELECTS (app#450): the fields that `NodeMetadata`
// declares, and no others.
//
// ⚠ That is not "the columns the app reads". On 2026-10-02 the components read eight of them
// (`node_id`, `hostname`, `build_version`, `exec_user`, `remote_addr`, `city`, `state`,
// `country`), and the map of app#443 reads `latitude` and `longitude`. The others were declared
// in the type before this list, and they stay until someone removes each from the type and from
// here in one change. ⚠ Each name is also a coupling: PostgREST refuses the WHOLE request for a
// column that does not exist, so the router cannot drop one of these before the app stops
// selecting it.
//
// The store read `select('*')`. So a column that the router adds reached the browser of every
// member on the day its migration was applied, with no change in the app and no line in a diff.
// Router migration `0239` added `isp` and `connection_type`, which come from MaxMind's paid
// databases and must not go on a page before the license question is decided
// (nobgp-router#1934). The app shows neither, and it had both.
//
// ⚠ ONE LIST, THREE PLACES THAT MUST AGREE, and `nodeMetadataColumns.test.ts` holds them:
//   - this list, which is what the two reads of the store select;
//   - the fields of `NodeMetadata` in `types/global.d.ts`, which is what the app can read. That
//     type has no index signature, so a read of a field it does not declare does not compile;
//   - so to read a new column, add it HERE and THERE in one change.
//
// ⚠ A STRING LITERAL, not a joined array: the typed client checks each name against
// `types/supabase.d.ts`, and only a literal gives it the names.
export const NODE_METADATA_COLUMNS =
  'node_id, boot_time, bot, build_architecture, build_platform, build_version, city, cloud, country, latitude, longitude, accuracy_radius, cpu_count, exec_user, hardware_addr, host_id, hostname, kernel_arch, kernel_version, local_addr, network_interface, os, platform, platform_family, platform_version, remote_addr, state, tailscale, total_memory, virtualization_role, virtualization_system'
